import { render, staticRenderFns } from "./VoucherPrepositions.vue?vue&type=template&id=2a1a3199&scoped=true&"
import script from "./VoucherPrepositions.vue?vue&type=script&lang=js&"
export * from "./VoucherPrepositions.vue?vue&type=script&lang=js&"
import style1 from "./VoucherPrepositions.vue?vue&type=style&index=1&id=2a1a3199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a3199",
  null
  
)

export default component.exports